export default __webpack_public_path__ + "static/tanmai-gopal-fa550551b3842b21daad515f5f10a6cb.png";